import {
  useCallback, useEffect, useMemo, useState,
} from 'react';

import {
  COLOR_SCHEME,
  prefersDark as readPrefersDark,
  readStoredScheme,
  resolveScheme,
  storeScheme,
  subscribeToSystemScheme,
} from 'styles/colorScheme';

export default function useColorScheme() {
  const [scheme, setSchemeState] = useState(readStoredScheme);
  const [systemPrefersDark, setSystemPrefersDark] = useState(readPrefersDark);

  useEffect(() => subscribeToSystemScheme(setSystemPrefersDark), []);

  const setScheme = useCallback((next) => {
    setSchemeState(next);
    storeScheme(next);
  }, []);

  const resolved = useMemo(
    () => resolveScheme(scheme, systemPrefersDark),
    [scheme, systemPrefersDark],
  );

  useEffect(() => {
    document.documentElement.dataset.colorScheme = resolved;

    // The pre-React script in public/index.html sets these two inline to avoid a flash of the wrong
    // scheme before this effect can run - inline wins over the stylesheet's own html{color-scheme}
    // and body{background-color} rules, so left in place they would survive every scheme switch made
    // from Profile. Clearing them here (this effect runs on the first render too) hands rendering
    // back to those rules, which already track the theme correctly.
    document.documentElement.style.colorScheme = '';
    document.documentElement.style.backgroundColor = '';
  }, [resolved]);

  return {
    scheme,
    setScheme,
    resolved,
    isDark: resolved === COLOR_SCHEME.dark,
  };
}
